export default {
  name: 'zmzj',
  components: {},
  data () {
    return {
      expertIp: 'http://files.travel-yuhuatai.com:82'
    }
  },
  // 创建元素
  mounted () {
  },
  // 方法定义
  methods: {
    // 点击跳转专家成果更多页面
    goMore () {
      const url = `${this.expertIp}/expert-code`
      window.open(url, '_blank')
    }
  }
}
